<template>
  <n-message-provider>
    <div class="outer">
      <img class="bg" src="@/assets/loginbg.jpg" autoplay loop muted />
      <div class="login" :class="{ active: activeMenu == 'login' }">
        <div class="logo">
          <img src="@/assets/logo.png" alt="" />
        </div>
        <div class="title">
          <p>灵眸智云工业监测数据平台</p>
        </div>
        <div class="form">
          <n-form-item label="用户名" required label-style="color:#888888">
            <n-input v-model:value="loginData.account" size="large" 
            type="text" placeholder="输入用户名" style="width: 350px" :suffix-icon="Calendar"/>
          </n-form-item>
          <n-form-item label="密码" required label-style="color:#888888">
            <n-input v-model:value="loginData.password" size="large"
              type="password" placeholder="输入密码" style="width: 350px" />
          </n-form-item>
        </div>
        <div class="btn">
          <n-spin :show="loginSpinning" size="small">
            <n-button type="primary" size="large" @click="login"
              style=" width: 340px; background-color: #3957a8; --n-border: 0 none;">登录</n-button>
          </n-spin>
        </div>
      </div>
    </div>
  </n-message-provider>
</template>

<script setup>
import { getCurrentInstance, inject, ref } from "vue";
import { useRouter } from "vue-router/dist/vue-router";
import { ElMessage } from "element-plus";
import { FlashOutline } from "@vicons/ionicons5";
import axios from "axios";
let activeMenu = ref("login");
const $axios = inject("$axios");
const router = useRouter();
let loginSpinning = ref(false);

// 登录用户数据
let loginData = ref({
  account: "",
  password: "",
});
// 引入全局变量-后端地址
const $baseURL =
  getCurrentInstance()?.appContext.config.globalProperties.$baseURL;
// 登录
function login() {
  console.log(loginData.value);
  let result = axios({
    method: "post",
    url: "http://118.25.85.189:8006/user/login",
    data: loginData.value,
    dataType: "jsonp",
    jsonp: "callback",
    jsonpCallback: "f",
  });
  //+"&room="+form.room
  result
    .then((res) => {
      console.log(res);
      if (res.data.code === 200) {
        ElMessage({
          message: "登录成功！",
          type: "success",
        });
        router.push("home");
      } else {
        ElMessage.error("账户或密码输入错误");
      }
    })
}
</script>

<style scoped lang="scss">
.outer {
  width: 100vw;
  height: 110vh;
  overflow: hidden;
  user-select: none;
  position: absolute;
  .bg {
    position: absolute;
    width: 100vw;
    height: 105vh;
    object-fit: cover;
  }

  .login {
    height: 470px;
    width: 350px;
    position: fixed;
    top: 50vh;
    transform: translate(-150%, -50%);
    background-color: #ffffffcf;
    box-shadow: 0px 1.1px 2.2px rgba(0, 0, 0, 0.006),
      0px 2.7px 5.3px rgba(0, 0, 0, 0.008), 0px 5px 10px rgba(0, 0, 0, 0.01),
      0px 8.9px 17.9px rgba(0, 0, 0, 0.012),
      0px 16.7px 33.4px rgba(0, 0, 0, 0.014), 0px 40px 80px rgba(0, 0, 0, 0.02);
    // border-radius:5px;
    border-top: 10px solid #3957a8;
    backdrop-filter: blur(5px);
    padding: 45px;

    .logo {
      width: 470px;
      height: 53px;
      padding-left: 90px;
      box-sizing: border-box;
      img {
        height: 50px;
      }
    }

    .title {
      width: 100%;
      color: #3957a8;
      margin-left: 8px;
      margin-top: 25px;
      margin-bottom: 50px;
      font-size: 26px;
      p {
        text-align: center;
        margin-top: 0;
        line-height: 10px;
      }
    }

    .form {
      margin: 0 0 0 8px;
    }

    .options {
      margin-left: 8px;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
    }

    .btn {
      margin: 30px 0 65px 8px;
      width: 350px !important;
    }
  }

  .copyright {
    color: #a4a4a4;
    display: flex;
    justify-content: center;
  }

  .login {
    opacity: 0;
    left: -25vw;
    transition: all 0.8s;
  }

  .login.active {
    opacity: 1;
    left: 50vw;
  }
}
</style>